interface Breadcrumbs {
  users: [string];
  results: [string];
  residues: [string, string];
  energies: [string, string];
  electricity: [string, string];
  water: [string, string];
  aviation: [string, string];
  publicTransport: [string, string];
  vehicles: [string, string];
  nutrition: [string, string];
}

export const BREADCRUMBS: Breadcrumbs = {
  users: ["Usuarios"],
  results: ["Resultados"],
  residues: ["Cálculos", "Residuos"],
  electricity: ["Cálculos", "Electricidad"],
  energies: ["Cálculos", "Energías"],
  water: ["Cálculos", "Agua"],
  aviation: ["Cálculos", "Aviación"],
  publicTransport: ["Cálculos", "Transporte público"],
  vehicles: ["Cálculos", "Vehículos"],
  nutrition: ["Cálculos", "Alimentación"]

};
